// File: src/components/About.jsx 1
import React from "react";

const About = () => {
  return (
    <section className="section" id="about">
      <h2>About Us</h2>
      <p style={{ maxWidth: "800px", margin: "0 auto" }}>
        We deliver transmission tower erection, HT/LT line stringing,
        substation construction, and EPC infrastructure projects across India.
      </p>
    </section>
  );
};

export default About;